// 프리오더는 한국만 대응
import 'dayjs/locale/ko';

import React from 'react';
import { IconInfoSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import dayjs from 'dayjs';

import { HelpDrawer, Portal } from '@common/toolbox';
import { EstimatedShippingDate, PdpShippingFeeType, PdpShopShippingCompany } from '@domains/pdp-common';

import { ShippingGeneralExtraInfoContainer } from '../containers/ShippingGeneralExtraInfoContainer';
import * as S from '../styles/preOrderstyles';
import { Divider } from '../styles/preOrderstyles';
import { ShippingFee } from './preOrder/ShippingFee';

dayjs.locale('ko');

// 프리오더 시작전 100126245
// 프리오더 진행중 100126251
// 프리오더 종료 100126252

interface PreOrderProps {
  open: boolean;
  setOpen: (bool: boolean) => void;
  shipping_details: {
    is_shipping_fee_free: boolean;
    shipping_fee: number;
    shipping_fee_type: PdpShippingFeeType;
    free_shipping_amount: number | null;
    shipping_company: PdpShopShippingCompany | null;
    additional_shipping_fee_text: string | null;
  };
  shipping_text: string;
  is_before: boolean;
  start_date: string;
  isEnded: boolean;
  countdown_text: string;
  end_at_text: string;
  estimated_shipping_date: EstimatedShippingDate;
}
export const PreOrder: React.FC<React.PropsWithChildren<PreOrderProps>> = ({
  open,
  setOpen,
  shipping_details,
  shipping_text,
  is_before,
  start_date,
  isEnded,
  countdown_text,
  end_at_text,
  estimated_shipping_date,
}) => {
  return (
    <S.PreOrderWrap>
      <div>배송</div>
      <div>
        <S.ShippingInfo>
          <S.PreOrderLabel>프리오더</S.PreOrderLabel>
          <Divider />
          <S.ShippingFee>
            <ShippingFee
              shipping_fee={shipping_details.shipping_fee}
              free_shipping_amount={shipping_details.free_shipping_amount}
              is_shipping_fee_free={shipping_details.is_shipping_fee_free}
            />
          </S.ShippingFee>
          <IconInfoSolid width={24} v3Color='gray200' onClick={() => setOpen(true)} />
        </S.ShippingInfo>
        <S.ShippingDetail>
          <p style={{ marginBottom: 5 }}>
            <b>{shipping_text}</b>부터 순차 발송
          </p>
          {is_before ? (
            <p>
              판매예정일: <b>{start_date}</b>
            </p>
          ) : (
            <>
              <p style={{ marginBottom: 2 }}>
                예약 마감
                {!isEnded && (
                  <>
                    <b> {countdown_text}</b> 남음
                  </>
                )}
              </p>
              <S.Deadline>({end_at_text} 마감)</S.Deadline>
            </>
          )}
        </S.ShippingDetail>
      </div>
      <HelpDrawer open={open} onClose={() => setOpen(false)} title='배송정보'>
        {shipping_details && (
          <ShippingGeneralExtraInfoContainer
            shipping_details={shipping_details}
            shipping_estimate_info={estimated_shipping_date.estimate_list}
          />
        )}
      </HelpDrawer>
    </S.PreOrderWrap>
  );
};
